import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TimezoneService } from 'src/app/services/timezone/timezone.service';

interface TimezoneOption { id: string; label: string; }

/**
 * Selector reutilizable de zona horaria para perfil candidato/empresa.
 * Carga la lista pública de zonas, muestra la actual y persiste el cambio.
 *
 * Uso:
 *   <app-timezone-selector [rol]="'candidato'"></app-timezone-selector>
 *   <app-timezone-selector [rol]="'empresa'"></app-timezone-selector>
 */
@Component({
  selector: 'app-timezone-selector',
  template: `
    <div style="display:flex;flex-direction:column;gap:6px;max-width:380px;">
      <label style="font-size:13px;font-weight:600;color:#334155;">
        Zona horaria
        <small style="display:block;font-weight:400;color:#64748b;font-size:12px;margin-top:2px;">
          Las fechas y horas se mostrarán en esta zona en toda la app y en los emails.
        </small>
      </label>
      <select [(ngModel)]="selected" (change)="onChange()"
              style="padding:8px 10px;border:1px solid #cbd5e1;border-radius:6px;font-size:13px;background:#fff;">
        <option *ngFor="let z of zonas" [value]="z.id">{{ z.label }}</option>
      </select>
      <small *ngIf="status" [style.color]="status === 'guardado' ? '#16a34a' : '#dc2626'"
             style="font-size:12px;margin-top:2px;">
        {{ status === 'guardado' ? '✓ Zona horaria actualizada' : '⚠ ' + status }}
      </small>
    </div>
  `,
})
export class TimezoneSelectorComponent implements OnInit {

  @Input() rol: 'candidato' | 'empresa' = 'candidato';

  zonas: TimezoneOption[] = [];
  selected: string = 'America/Mexico_City';
  status: string = '';

  constructor(private http: HttpClient, private tz: TimezoneService) {}

  ngOnInit(): void {
    this.selected = this.tz.getCurrentZone();
    this.http.get<any>(`${environment.baseApi}/publico/timezones`).subscribe({
      next: r => { this.zonas = (r?.data || []) as TimezoneOption[]; },
      error: () => { /* sin lista — el select queda vacío pero el actual se ve */ }
    });
  }

  onChange(): void {
    this.status = '';
    this.tz.setZone(this.selected, true, this.rol).subscribe(resp => {
      this.status = resp?.error ? resp.error : 'guardado';
      setTimeout(() => this.status = '', 3000);
    });
  }
}
